import React from "react";
import { Route, Switch } from "react-router-dom";
import RadioHome from "./RadioHome";

function RadioRoutes() {
  return (
    <Switch>
      <Route path="/:farm_id/radio/" component={RadioHome} />
    </Switch>
  );
}

export default RadioRoutes;
